import { useEffect, useRef, useState } from 'react';
import { saveImage } from '../download';

// Xem ảnh phóng to: pinch (điện thoại) + lăn chuột/nút (máy tính) + kéo để di ảnh.
// Bấm đúp / nút để phóng nhanh; Esc hoặc bấm nền tối để đóng. Nút ⬇ để tải ảnh về máy.
export default function ImageLightbox({ src, filename, onClose }) {
  const [scale, setScale] = useState(1);
  const [tx, setTx] = useState(0);
  const [ty, setTy] = useState(0);
  const [saving, setSaving] = useState(false);
  const ptrs = useRef(new Map()); // pointerId -> {x,y}
  const start = useRef(null);

  const clamp = (s) => Math.min(6, Math.max(1, s));
  const reset = () => { setScale(1); setTx(0); setTy(0); };
  const zoomBy = (f) => setScale((s) => { const n = clamp(s * f); if (n === 1) { setTx(0); setTy(0); } return n; });

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const onWheel = (e) => { e.preventDefault(); zoomBy(e.deltaY < 0 ? 1.15 : 0.87); };

  // Tải ảnh đang xem về máy (web: lưu thẳng; native: mở share sheet để Lưu vào Ảnh/Files).
  const download = async () => {
    if (saving) return;
    setSaving(true);
    try { await saveImage(src, filename); }
    catch (e) { console.error('[lightbox] tải ảnh lỗi:', e?.message || e); }
    finally { setSaving(false); }
  };

  const onPointerDown = (e) => {
    ptrs.current.set(e.pointerId, { x: e.clientX, y: e.clientY });
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch { /* ignore */ }
    if (ptrs.current.size === 2) {
      const [a, b] = [...ptrs.current.values()];
      start.current = { dist: Math.hypot(a.x - b.x, a.y - b.y), scale };
    } else {
      start.current = { x: e.clientX, y: e.clientY, tx, ty };
    }
  };
  const onPointerMove = (e) => {
    if (!ptrs.current.has(e.pointerId)) return;
    ptrs.current.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (ptrs.current.size >= 2 && start.current?.dist) {
      const [a, b] = [...ptrs.current.values()];
      setScale(clamp(start.current.scale * (Math.hypot(a.x - b.x, a.y - b.y) / start.current.dist)));
    } else if (ptrs.current.size === 1 && scale > 1 && start.current) {
      setTx(start.current.tx + (e.clientX - start.current.x));
      setTy(start.current.ty + (e.clientY - start.current.y));
    }
  };
  const onPointerUp = (e) => {
    ptrs.current.delete(e.pointerId);
    const rest = [...ptrs.current.values()];
    start.current = rest.length === 1 ? { x: rest[0].x, y: rest[0].y, tx, ty } : null;
  };

  return (
    <div className="chat-lightbox" onClick={() => scale === 1 && onClose()}>
      <div className="chat-lightbox-tools" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={() => zoomBy(0.8)} title="Thu nhỏ">−</button>
        <button type="button" onClick={() => zoomBy(1.25)} title="Phóng to">+</button>
        <button type="button" onClick={reset} title="Cỡ gốc">⟲</button>
        <button type="button" className="chat-lightbox-dl" onClick={download} disabled={saving} title="Tải ảnh về máy">{saving ? '⏳' : '⬇'}</button>
        <button type="button" onClick={onClose} title="Đóng">×</button>
      </div>
      <img
        src={src}
        alt=""
        decoding="async"
        draggable={false}
        onClick={(e) => e.stopPropagation()}
        onDoubleClick={(e) => { e.stopPropagation(); scale > 1 ? reset() : setScale(2.5); }}
        onWheel={onWheel}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
        style={{
          transform: `translate(${tx}px, ${ty}px) scale(${scale})`,
          cursor: scale > 1 ? 'grab' : 'zoom-in',
          touchAction: 'none',
          transition: ptrs.current.size ? 'none' : 'transform .12s ease-out',
        }}
      />
    </div>
  );
}
